import { stringifyQueryString as query} from 'external/react'
import {get} from 'external/axios';

export class AccountingService {
	 
  async searchPayouts(id: string, searchParams: any) {
    const url = `/accounting/search-payouts?${query({id, ...searchParams})}`
    return get(url)
  }

  async getPayoutDetail(id: string, payoutId: string) {
    const url = `/accounting/payout/${payoutId}?${query({id})}`
    return get(url)
  }

  async exportPayouts(id: string, params: { from?: string; to?: string }) {
    const url = `/accounting/export-payouts?${query({id, ...params})}`
    return get(url)
  }

}

export const accountingService = new AccountingService();